export function replacePink(content: string): string {
  return content.replace(
    /\[([^\[\]]+)\]/g,
    `<span class="text-pink-500">$1</span>`
  )
}
